import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function ToperNotePhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="topernote" />

    </>
  );
}

export default ToperNotePhysTopics;